import React, { useState } from "react";

const CircleRadioButton = ({ value, selected, onClick, submitted }) => {
  const handleClick = () => {
    onClick(value);
  };

  return (
    <button
      disabled={submitted}
      className={`circle-radio-btn ${selected ? "selected" : ""}`}
      onClick={handleClick}
    >
      {value}
    </button>
  );
};

export default CircleRadioButton;
